export const ArrowRight = ({className}: {className?: string}) => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none" className={className}>
          <path
              d="M0.738905 0.495028C0.405718 0.313323 -0.000487472 0.554483 -0.000486809 0.933996L-0.000472588 9.06647C-0.000471924 9.44598 0.405732 9.68714 0.738918 9.50544L8.19508 5.43921C8.54255 5.24971 8.54256 4.75078 8.19508 4.56128L0.738905 0.495028Z"
          />
      </svg>
  );
}
